// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3_t8g","additionalInfo":"AgreementModal_additionalInfo__3XlOH"};